import styled from "styled-components";
import { ButtonStyled } from "../../styles/GenericButton";
import { T } from "../../styles/Theme";
import { GenericButton } from "../UI-KIT/GenereicButton";

const Banner = () => {
  const url = "https://tiendaempresas.entel.cl/equipos.html";

  const handleClick = () => {
    window.open(url, "_blank");
  };

  return (
    <Container>
      <div className="text">Conoce todos los equipos que<br /><a>Entel Empresas tiene para tu negocio</a></div>
      <div className="buttonContainer">
        <ButtonBanner onClick={handleClick}
          bc={T.primary}
          c="white"
        >
          Ver todos los equipos
        </ButtonBanner>
        </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  width: 85%;
  height: 70px;
  padding-top: 0px;
  margin: 20px 50px;
  background-color: ${T.secondary};
  border-radius: 10px;
  box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.2);

  .text {
    width: 65%;
    font-size: 20px;
    font-weight: bold;
    padding: 10px 0 0 20px;
  }

  .text a {
    font-size: 16px;
    font-weight: bold;
    padding: 0
  }

  .buttonContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40%;
    padding: 18px 20px 0 0;
  }

  @media (max-width: 700px) {
    display: none;
  }
`;

const ButtonBanner = styled(ButtonStyled)`
  height: 40px;

  :hover {
    background-color: white;
    color: ${T.primary};
  }
`;

export default Banner;